import styles from './ConfiguracoesPage.module.css'

export function ConfiguracoesPage() {
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Configurações</h1>
        <p className={styles.subtitle}>Gerencie as configurações do sistema</p>
      </div>
    </div>
  )
}
